import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "CollapseBorder",
  "use": "CollapseBorder-usage",
  "viewBox": "-4.253 -0.209 44.483 24.483",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-4.253 -0.209 44.483 24.483\" id=\"CollapseBorder\"><path fill=\"#FFF\" d=\"M18 23.991l22-24.2h-6.682l-15.4 17.155L2.66-.209H-4z\" /><path d=\"M18 19.591L.4-.209h35.2L18 19.591z\" /><path fill=\"#FFF\" d=\"M11.175 4.981h13.671l-6.934 6.934z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol